import { render, staticRenderFns } from "./dashboard-card-collapsable.vue?vue&type=template&id=63ba6884&scoped=true&"
import script from "./dashboard-card-collapsable.vue?vue&type=script&lang=js&"
export * from "./dashboard-card-collapsable.vue?vue&type=script&lang=js&"
import style0 from "./dashboard-card-collapsable.vue?vue&type=style&index=0&id=63ba6884&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63ba6884",
  null
  
)

export default component.exports